import React from "react";
import { ArrowRight } from "lucide-react";
import { hristinaImage } from "../mock";

export default function AboutSection() {
  return (
    <section className="bg-[color:var(--dms-cream-2)] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_-20px_rgba(20,36,61,0.35)]">
          <img src={hristinaImage} alt="Hristina, founder" className="w-full h-[560px] object-cover" />
        </div>
        <div>
          <p className="kicker">About Design My Story</p>
          <h2 className="font-serif text-4xl md:text-5xl text-[color:var(--dms-navy)] mt-4 leading-tight">
            Life is full of stories, Jesus is designing yours
          </h2>
          <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mt-5" />
          <p className="mt-6 text-[color:var(--dms-navy)]/75 leading-relaxed">
            I started Design my story after walking through seasons of brokeness where only God’s Grace carried me. This brand exists to remind every person that no matter what their past holds, Jesus is still writing their story – with purpose beauty and love.
          </p>
          <blockquote className="mt-6 border-l-4 border-[color:var(--dms-peach)] pl-5 italic text-[color:var(--dms-navy)]/80 font-serif text-lg">
            “For I know the plans I have for you,” declares the Lord, “plans to prosper you and not to harm you, plans to give you hope and a future.”
            <footer className="not-italic text-sm font-sans mt-2 text-[color:var(--dms-peach)] font-semibold tracking-wider">JEREMIAH 29:11</footer>
          </blockquote>
          <div className="mt-8">
            <a href="#about" className="btn-navy">Read my story <ArrowRight className="w-4 h-4" /></a>
          </div>
        </div>
      </div>
    </section>
  );
}
